import { createSelector } from "@reduxjs/toolkit";
import { consentTargets } from "../../types/ConsentTarget.types";
function isConsentOrderAttribute(attribute) {
    return consentTargets.includes(attribute.placement);
}
export const selectOrderAttributes = createSelector((state) => { var _a; return (_a = state.checkout.orderAttributes) !== null && _a !== void 0 ? _a : []; }, (orderAttributes) => orderAttributes.data.filter((attribute) => !isConsentOrderAttribute(attribute)));
//# sourceMappingURL=selectOrderAttributes.js.map